export const formatPercent = progress => Math.floor(progress * 100)


// WEBPACK FOOTER //
// ./src/scripts/helpers/FormatHelper.js